/**
 * Created by Administrador on 12/12/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig)

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('customerCorporates', {
                parent: 'app',
                url: '/customerCorporates?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/customerCorporate/customerCorporates.html',
                        controller: 'customerCorporateCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['customerCorporate']);
                    }],
                    customerCorporates: ['customerCorporateService','$stateParams', function(customerCorporateService,$stateParams){
                        return customerCorporateService.getCustomerCorporates($stateParams.page, $stateParams.size,true)
                    }]
                }
            })
            .state('customerCorporateNew', {
                parent: 'app',
                url: '/customerCorporate/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/customerCorporate/newCustomerCorporate.html',
                        controller: 'newCustomerCorporateCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['customerCorporate']);
                    }],
                    parents: ['customerCorporateService',function(customerCorporateService){
                        return customerCorporateService.getParents()
                    }],
                    regions: ['regionService',function(regionService){
                        return regionService.getRegions()
                    }]
                }
            })
            .state('customerCorporateEdit', {
                parent: 'app',
                url: '/customerCorporate/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/customerCorporate/editCustomerCorporate.html',
                        controller: 'editCustomerCorporateCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['customerCorporate']);
                    }],
                    customerCorporate: ['customerCorporateService', '$stateParams', function(customerCorporateService, $stateParams){
                        return customerCorporateService.getCustomerCorporate($stateParams.id)
                    }],
                    regions: ['regionService',function(regionService){
                        return regionService.getRegions()
                    }]
                }
            })
            .state('customerCorporateDelete', {
                parent: 'customerCorporates',
                url: '/customerCorporate/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/customerCorporate/deleteCustomerCorporate.html',
                        controller: 'deleteCustomerCorporateCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'customerCorporate': ['customerCorporateService', function(customerCorporateService) {
                                return customerCorporateService.getCustomerCorporate($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('customerCorporates', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('customerCorporateSettings', {
                parent: 'app',
                url: '/customerCorporate/:id/baseRate?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/customerCorporate/baseRateCustomerCorporate.html',
                        controller: 'baseRateCustomerCorporateCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['customerCorporate','baseRates']);
                    }],
                    customerCorporate: ['customerCorporateService', '$stateParams', function(customerCorporateService, $stateParams){
                        return customerCorporateService.getCustomerCorporate($stateParams.id)
                    }],
                    baseRates: ['baseRateService','$stateParams',function(baseRateService,$stateParams){
                        return baseRateService.getBaseRateByCustomerCorporate($stateParams.page, $stateParams.size, $stateParams.id);
                    }]
                }
            })
            .state('customerCorporateFinancialState', {
                parent: 'app',
                url: '/customerCorporate/:id/financialState',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/customerCorporate/financialStateCustomerCorporate.html',
                        controller: 'financialStateCustomerCorporateCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['customerCorporate','baseRates']);
                    }],
                    customerCorporate: ['customerCorporateService', '$stateParams', function(customerCorporateService, $stateParams){
                        return customerCorporateService.getCustomerCorporate($stateParams.id)
                    }]
                }
            });
    }
})();
